import React from 'react'
import { Box, Grid, Typography, Paper, makeStyles } from '@material-ui/core'
import { FieldArray } from 'react-final-form-arrays'
import MyTextfield from '../../../../control/textfield/textfield'
import ProjectRow from './ProjectRow'
import { ProjectRequest } from '../agendaTypes'
import useTranslate from '../../../../i18n/useTranslate'
import { useField } from 'react-final-form'

const SubAgendaRow: React.FC<{
    namePrefix: string
    onRemove?: () => void
    parentIndex: number
    subIndex: number
    canEdit?: boolean
    searchTbl: (payload: ProjectRequest) => Promise<any>
}> = ({ namePrefix, onRemove, parentIndex, subIndex, canEdit = true, searchTbl }) => {
    const classes = useStyles()
    const t = useTranslate()
    const displayNumber = `${parentIndex + 1}.${subIndex + 1}`
    const {
        input: { value: subTitle },
    } = useField<string>(`${namePrefix}.title`, { subscription: { value: true } })

    const trimmed = (subTitle ?? '').trim()
    const agendaLabel = t.get('UM.SETTING_AGENDA.AGENDA_ITEMS.AGENDA_TITLE', [displayNumber])
    const headerText = trimmed ? `${agendaLabel} ${trimmed}` : agendaLabel

    return (
        <Box className={classes.rowCard}>
            <Box className={classes.sectionTitleRow} style={{ marginBottom: 12 }}>
                <Typography variant="h6">{headerText}</Typography>
            </Box>

            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <MyTextfield
                        name={`${namePrefix}.topicSummary`}
                        resetButtom
                        materialInputProps={{
                            label: t.get('UM.SETTING_AGENDA.MEETING_SUMMARY'),
                            placeholder: t.get('UM.SETTING_AGENDA.MEETING_SUMMARY'),
                            disabled: !canEdit,
                            multiline: true,
                            rows: 2,
                        }}
                    />
                </Grid>

                <Grid item xs={12}>
                    <Box className={classes.sectionTitleRow}>
                        <Typography variant="h6">
                            {t.get('UM.SETTING_AGENDA.AGENDA_ITEMS.PROJECT_CONSIDERATION')}
                        </Typography>
                    </Box>

                    <FieldArray name={`${namePrefix}.projects`}>
                        {({ fields }) => {
                            const count =
                                (fields as any)?.length ??
                                (Array.isArray((fields as any)?.value) ? (fields as any).value.length : 0)

                            return (
                                <>
                                    {count === 0 && (
                                        <Paper elevation={0} variant="outlined" className={classes.emptyCard}>
                                            <Typography variant="body2" color="textSecondary">
                                                {t.get('UM.SETTING_AGENDA.AGENDA_ITEMS.NO_ITEMS')}
                                            </Typography>
                                        </Paper>
                                    )}

                                    {fields.map((pfx: string, pIdx: number) => (
                                        <ProjectRow
                                            key={pfx}
                                            namePrefix={pfx}
                                            canEdit={canEdit}
                                            onRemove={() => fields.remove(pIdx)}
                                        />
                                    ))}
                                </>
                            )
                        }}
                    </FieldArray>
                </Grid>
            </Grid>
        </Box>
    )
}

const useStyles = makeStyles((theme) => ({
    rowCard: {
        border: '1px solid #E5E7EB',
        borderRadius: 8,
        padding: theme.spacing(2),
        marginTop: 16,
    },
    sectionTitleRow: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: theme.spacing(2),
    },
    emptyCard: {
        padding: theme.spacing(2),
        borderRadius: 8,
        background: '#F9FAFB',
        border: '1px dashed #E5E7EB',
        marginBottom: theme.spacing(2),
    },
}))

export default React.memo(SubAgendaRow)
